module.exports = "<div class=\"pull-right admin-grid-buttons\">\n    <a ui-sref=\"^.webhooks.new\">\n        <i class=\"grid-button-icon icon icon-new\"></i>New Webhook\n    </a>\n</div>\n<jf-grid\n        grid-options=\"Webhooks.gridOptions\"\n        filter-field=\"name\"\n        object-name=\"webhook\"\n        auto-focus=\"true\">\n</jf-grid>\n"


//////////////////
// WEBPACK FOOTER
// ./modules/xray/states/settings/tabs/webhooks/webhooks.html
// module id = 701
// module chunks = 6